import { render, staticRenderFns } from "./LeadTable.vue?vue&type=template&id=2a42543e&scoped=true"
import script from "./LeadTable.vue?vue&type=script&lang=js"
export * from "./LeadTable.vue?vue&type=script&lang=js"
import style0 from "./LeadTable.vue?vue&type=style&index=0&id=2a42543e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a42543e",
  null
  
)

export default component.exports